var lib_geometry = require("lib-geometry");

var PosData = {
    addPos: function (pos) {
        this.pos = this.value("pos", true, lib_geometry.Coord.validator);
        if(pos != undefined) this.pos(pos);
    },

    getPos: function () {
        return this.pos();
    },

    setPos: function (pos) {
        this.pos(pos);
    },

    move: function (vec) {
        this.pos(this.pos().add(vec));
    },

    rotate: function (angle, center) {
        if (center !== undefined) {
            this.pos(this.pos().rotate(angle, center));
        }
    },

    flip: function (flipline) {
        if(flipline !== undefined) {
            this.pos(this.pos().flip(flipline));
        }
    },

    getTransform: function() {
        var transform = new lib_geometry.Transform();
        transform.translation = this.pos();
        return transform;
    }
};

module.exports = PosData;
